var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.497,
    height: 49.497,
    viewBox: "0 0 49.497 49.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(-2.121 24.749) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78927",
    "data-name": "Path 78927",
    d: "M35,19A16,16,0,1,1,19,3,16,16,0,0,1,35,19Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#db3a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78928",
    "data-name": "Path 78928",
    d: "M18,12V24.8",
    transform: "translate(1 0.6)",
    fill: "none",
    stroke: "#db3a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78929",
    "data-name": "Path 78929",
    d: "M12,18H24.8",
    transform: "translate(0.6 1)",
    fill: "none",
    stroke: "#db3a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.263cfa360a33068408bf7399ad633bc3.svg";
export { ForwardRef as ReactComponent };